import React, { Component } from "react";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      startWeekDay: "",
      endWeekDay: "",
      timeZone: "",
      startTime: "",
      endTime: "",
      isDefault: false,
      healthSystemId: "",
      hospitalId: "",
      serviceLineId: "",
      value: [],
      procedureData: "",
      loadedData: [],
      disableAddButton: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit.svg",
      contentEditable: "false",
      hidden: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      pageNum: null,
      paginationValue: 10,
      searchTerm: "",
      isLoading: true,
      noMatchingData: false,
    };
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.loadedWhenInfo = [];
    this.loadedStartWeekDays = [];
    this.loadedEndWeekDays = [];
    this.loadedAvailability = [];
    this.loadedTimeZone = [];
  }

  addNewContactInfo = () => {
    console.log("Adding Empty Row");
    var thisController = this;
    thisController.state.paginationValue =
      thisController.state.paginationValue + 5;

    if (thisController.state.pageNum != 0) {
      thisController.setState({ pageNum: 0 });
    }
    thisController.state.loadedData.unshift({
      id: "",
      name: "",
    });
    thisController.state.disableAddButton = true;
    thisController.setState(thisController.state);
  };

  saveContactInfoDetails = (row, e) => {
    row.contactNumber = document
      .getElementById("contactNumber" + row.id)
      .innerText.trim();
    row.address = document.getElementById("address" + row.id).innerText.trim();
    row.startTime = document.getElementById("startTime" + row.id).value;
    row.endTime = document.getElementById("endTime" + row.id).value;
    row.startWeekDay = document.getElementById("startWeekDay" + row.id).value;
    row.endWeekDay = document.getElementById("endWeekDay" + row.id).value;
    row.timeZone = document.getElementById("timeZone" + row.id).value;
    row.default = document.getElementById("isDefault" + row.id).checked;
    row.description = document
      .getElementById("description" + row.id)
      .innerText.trim();
    this.state.editedId = "-1";
    this.setState(this.state);

    var addContactUsController = this;
    var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{6,17}|\(\d{3}\)\s\d{3}-\d{4}$/
    );
    //new RegExp(/^\+?\d+[\d\s-]*\d+$/);

    // new RegExp(/^(\+1)?[\d\s-]+$/);
    var addressPattern = new RegExp(/^([a-zA-Z0-9 /''()#.,-])*$/);

    if (
      !row.default &&
      (
        row.startTime == "" ||
        row.endTime == "" ||
        row.startWeekDay == "" ||
        row.endWeekDay == "")
    ) {
      addContactUsController.notifyMsgFieldEmpty();
    } else if (
      row.default &&
      (row.startWeekDay == "" || row.endWeekDay == "")
    ) {
      addContactUsController.notifyMsgFieldEmpty();
    } else if (
      row.contactNumber != "" &&
      !contactNumberPattern.test(row.contactNumber)
    ) {
      addContactUsController.notifyImproperContactNumber();
    } else {
      var dataToSave = {
        startTime: row.startTime,
        endTime: row.endTime,
        startWeekDay: row.startWeekDay,
        endWeekDay: row.endWeekDay,
        default: row.default,
        providerId: JSON.parse(localStorage.getItem("user_details"))["userId"],
        timeZone: row.timeZone,
        contactNumber: row.contactNumber,
        address: row.address,
        availability: row.availability,
        description: row.description,
      };
      $.ajax({
        url: "/my-jeeva-api/add-contact-info",

        method: "POST",
        data: JSON.stringify(dataToSave),
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        success: function (res) {
          if (res.success === true) {
            addContactUsController.notifyContactInfoAdded();
            addContactUsController.fetchContactInfo();
            addContactUsController.setState({ disableAddButton: false });
          } else {
            addContactUsController.notifyFailed(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };
  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields
      </b>,
      {
        position: "top-center",
      }
    );
  }

  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no contact data present. </p>
    </div>
  );

  notifyImproperContactNumber() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid contact number
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperAddress() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid address
      </b>,
      {
        position: "top-center",
      }
    );
  }

  updateContactInfoDetails = (row, e) => {
    var updateController = this;
    row.contactNumber = document
      .getElementById("contactNumber" + row.id)
      .innerText.trim();
    row.address = document.getElementById("address" + row.id).innerText.trim();
    row.startTime = document.getElementById("startTime" + row.id).value;
    row.endTime = document.getElementById("endTime" + row.id).value;
    row.timeZone = document.getElementById("timeZone" + row.id).value;
    row.startWeekDay = document.getElementById("startWeekDay" + row.id).value;
    row.endWeekDay = document.getElementById("endWeekDay" + row.id).value;
    row.default = document.getElementById("isDefault" + row.id).checked;
    row.description = document
      .getElementById("description" + row.id)
      .innerText.trim();

    var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{6,17}|\(\d{3}\)\s\d{3}-\d{4}$/
    );
    //new RegExp(/^\+?\d+[\d\s-]*\d+$/);
    // new RegExp(/^(\+1)?[\d\s-]+$/);
    var addressPattern = new RegExp(/^([a-zA-Z0-9 /''()#.,-])*$/);

    if (
      !row.default &&
      (
        row.startTime == "" ||
        row.endTime == "" ||
        row.startWeekDay == "" ||
        row.endWeekDay == "")
    ) {
      updateController.notifyMsgFieldEmpty();
    } else if (
      row.default &&
      (row.startWeekDay == "" || row.endWeekDay == "")
    ) {
      updateController.notifyMsgFieldEmpty();
    } else if (
      row.contactNumber != "" &&
      !contactNumberPattern.test(row.contactNumber)
    ) {
      updateController.notifyImproperContactNumber();
    }
    else {
      var saveData = {
        id: row.id,
        startTime: row.startTime,
        endTime: row.endTime,
        startWeekDay: row.startWeekDay,
        endWeekDay: row.endWeekDay,
        default: row.default,
        providerId: JSON.parse(localStorage.getItem("user_details"))["userId"],
        timeZone: row.timeZone,
        contactNumber: row.contactNumber,
        address: row.address,
        availability: row.availability,
        description: row.description,
      };

      $.ajax({
        url: "/my-jeeva-api/update-contact-info",
        method: "PATCH",
        data: JSON.stringify(saveData),
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        success: function (res) {
          if (res.success === true) {
            if (res.success === true) {
              updateController.state.editedId = "-1";
              updateController.notifyContactUsUpdated();
              updateController.fetchContactInfo();
            } else {
              updateController.notifyFailed(res.result);
            }
          } else {
            updateController.notifyFailedToUpdate(res.result);
            updateController.state.disableAddButton = false;
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/my-jeeva/login";
          }
        },
      });
    }
  };

  notifyContactUsUpdated() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Contact information updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedToUpdate(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  makeCelledit(row, e) {
    this.markAsBeingEdited(row.id);
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }

  notifyError() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Oops! Error occurred.Please try again
      </b>,
      {
        position: "top-center",
      }
    );
  }

  componentDidMount() {
    this.fetchTimeZoneApi();

  }
  fetchWeekDaysApi() {
    var thisController = this;
    var responseData = [];
    $.ajax({
      url: "/my-jeeva-api/week-days",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          var response = res.result;
          var length = response.length;
          thisController.loadedStartWeekDays = [];
          thisController.loadedEndWeekDays = [];
          for (var i = 0; i < length; i++) {
            thisController.loadedStartWeekDays[i] = response[i];
            thisController.loadedEndWeekDays[i] = response[i];
          }

          thisController.fetchAvailabilityData();
        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva/";
        }
      },
    });
  }

  fetchAvailabilityData() {
    var thisController = this;
    var responseData = [];
    $.ajax({
      url: "/my-jeeva-api/availability",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          var response = res.result;
          var length = response.length;
          thisController.loadedAvailability = [];
          for (var i = 0; i < length; i++) {
            thisController.loadedAvailability[i] = response[i];
          }
          thisController.fetchContactInfo();
        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva/";
        }
      },
    });
  }
  fetchTimeZoneApi = () => {
    var timeZoneController = this;
    $.ajax({
      url: "/my-jeeva-api/time-zones",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          timeZoneController.state.showLoader = true;
          timeZoneController.setState(timeZoneController.state);
          var loadTimeZone = res.result;
          var numberOfTimeZone = loadTimeZone.length;
          timeZoneController.loadedTimeZone = [];
          for (var i = 0; i < numberOfTimeZone; i++) {
            timeZoneController.loadedTimeZone[i] = loadTimeZone[i];
          }
          timeZoneController.fetchWeekDaysApi();
        } else {
          // timeZoneController.notifyError(res.result);
        }
      },
    });
  };

  deleteContactInfoDetails = (id) => {
    let contactInfoDetails = this.state.loadedData;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteApiViewController.setState({ hideDeletePopup: false });
      deleteApiViewController.setState({ hideDeleteSuccessPopup: true });
      contactInfoDetails.splice(id, 1);
    } else {
      $.ajax({
        url: "/my-jeeva-api/delete-contact-info/" + id,

        method: "DELETE",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            deleteApiViewController.setState({ deleteRow: true });
            deleteApiViewController.setState({ hideDeletePopup: false });
            deleteApiViewController.notifyDelete();
            contactInfoDetails.splice(id, 1);
          } else {
            // deleteApiViewController.notifyError();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }

    if (deleteApiViewController.deleteRow) {

      deleteApiViewController.setState({ loadedData: contactInfoDetails });
    }

    deleteApiViewController.refreshData();
    deleteApiViewController.fetchContactInfo();
  };
  fetchContactInfo() {
    var thisController = this;

    $.ajax({
      url: "/my-jeeva-api/contact-info",
      method: "GET",
      data: {
        providerId: JSON.parse(localStorage.getItem("user_details"))["userId"],
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.setState({
            loadedData: res.result,
            showLoader: true,
            disableAddButton: false,
            isLoading: false,
            noMatchingData: false,
          });
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva/";
        }
      },
    });
    // }
  }



  refreshData = (id) => {
    this.setState({
      editedId: id,
      disabled: false,
      isLoading: true,
      searchTerm: "",
      noMatchingData: false,
      loadedData: []
    });
    this.fetchContactInfo();
  };

  notifyContactInfoAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Contact information added successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedLoad(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  notifyDelete() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;ContactUs detail deleted successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  openDeletePopUp = (id) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: "Are you sure you want to delete this contact ? ",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteContactInfoDetails(id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  notifyFailed(response) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;{response}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  onPageChange = (e) => {
    this.setState({ pageNum: e });
  };

  handleChangeStartTime = (row, e) => {
    row.contactNumber = document.getElementById(
      "contactNumber" + row.id
    ).innerText;
    row.address = document.getElementById("address" + row.id).innerText;
    row.startTime = e.target.value;
    row.startTime = document.getElementById("startTime" + row.id).value;
    this.setState(this.state);
  };
  handleChangeEndTime = (row, e) => {
    row.contactNumber = document.getElementById(
      "contactNumber" + row.id
    ).innerText;
    row.address = document.getElementById("address" + row.id).innerText;
    row.endTime = e.target.value;
    row.endTime = document.getElementById("endTime" + row.id).value;
    this.setState(this.state);
  };
  handleChangeStartWeekDay = (row, e) => {
    row.default = document.getElementById("isDefault" + row.id).checked;
    row.contactNumber = document.getElementById(
      "contactNumber" + row.id
    ).innerText;
    row.address = document.getElementById("address" + row.id).innerText;
    row.startTime = document.getElementById("startTime" + row.id).value;
    row.endTime = document.getElementById("endTime" + row.id).value;
    row.startWeekDay = document.getElementById("startWeekDay" + row.id).value;
    row.endWeekDay = document.getElementById("endWeekDay" + row.id).value;
    row.timeZone = document.getElementById("timeZone" + row.id).value;
    row.availability = document.getElementById("availability" + row.id).value;
    this.state.startWeekDay = e.target.value;
    this.setState(this.state);
  };
  handleChangeEndWeekDay = (row, e) => {
    row.default = document.getElementById("isDefault" + row.id).checked;
    row.contactNumber = document.getElementById(
      "contactNumber" + row.id
    ).innerText;
    row.address = document.getElementById("address" + row.id).innerText;
    row.startTime = document.getElementById("startTime" + row.id).value;
    row.endTime = document.getElementById("endTime" + row.id).value;
    row.endWeekDay = document.getElementById("endWeekDay" + row.id).value;
    row.startWeekDay = document.getElementById("startWeekDay" + row.id).value;
    row.availability = document.getElementById("availability" + row.id).value;
    row.timeZone = document.getElementById("timeZone" + row.id).value;
    this.state.endWeekDay = e.target.value;
    this.setState(this.state);
  };
  availabilityHandleChange = (row, e) => {
    row.default = document.getElementById("isDefault" + row.id).checked;
    row.contactNumber = document.getElementById(
      "contactNumber" + row.id
    ).innerText;
    row.address = document.getElementById("address" + row.id).innerText;
    row.startTime = document.getElementById("startTime" + row.id).value;
    row.endTime = document.getElementById("endTime" + row.id).value;
    row.endWeekDay = document.getElementById("endWeekDay" + row.id).value;
    row.startWeekDay = document.getElementById("startWeekDay" + row.id).value;
    row.availability = document.getElementById("availability" + row.id).value;
    row.timeZone = document.getElementById("timeZone" + row.id).value;

    this.setState(this.state);
  };

  handleDefaultChange = (row, e) => {
    row.default = document.getElementById("isDefault" + row.id).checked;
    row.contactNumber = document.getElementById(
      "contactNumber" + row.id
    ).innerText;
    row.address = document.getElementById("address" + row.id).innerText;
    row.startTime = document.getElementById("startTime" + row.id).value;
    row.endTime = document.getElementById("endTime" + row.id).value;
    row.endWeekDay = document.getElementById("endWeekDay" + row.id).value;
    row.startWeekDay = document.getElementById("startWeekDay" + row.id).value;
    row.timeZone = document.getElementById("timeZone" + row.id).value;
    row.availability = document.getElementById("availability" + row.id).value;
    this.state.isDefault = e.target.checked
    this.setState(this.state);
  };
  timeZonehandleChange = (row, e) => {
    row.default = document.getElementById("isDefault" + row.id).checked;
    row.contactNumber = document.getElementById(
      "contactNumber" + row.id
    ).innerText;
    row.address = document.getElementById("address" + row.id).innerText;
    row.startTime = document.getElementById("startTime" + row.id).value;
    row.endTime = document.getElementById("endTime" + row.id).value;
    row.startWeekDay = document.getElementById("startWeekDay" + row.id).value;
    row.endWeekDay = document.getElementById("endWeekDay" + row.id).value;
    row.availability = document.getElementById("availability" + row.id).value;
    row.timeZone = document.getElementById("timeZone" + row.id).value;
    this.state.timeZone = e.target.value;
    this.setState(this.state);
    // this.state.timeZone = e.target.value;
    // document.getElementById("timeZone").value = e.target.value;
    // this.setState(this.state);
    // this.fetchContactInfo();
  };

  caseInsensitiveSort = (field) => (rowA, rowB) => {
    const a = rowA[field] ? rowA[field].toLowerCase() : '';
    const b = rowB[field] ? rowB[field].toLowerCase() : '';

    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };

  handleSearch = (event) => {
    var thisController = this;
    thisController.state.searchTerm = event.target.value;
    thisController.state.isLoading = true;
    thisController.state.loadedData = [];
    thisController.setState(thisController.state);

    $.ajax({
      url: "/my-jeeva-api/search-contact-info",
      method: "GET",
      data: {
        searchTerm: thisController.state.searchTerm,
        providerId: JSON.parse(localStorage.getItem("user_details"))["userId"],
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          if (res.result.length > 0) {
            thisController.state.loadedData = [];
            thisController.state.isLoading = false;
            thisController.state.noMatchingData = false;
            thisController.setState(thisController.state);
            thisController.state.loadedData = res.result;
            thisController.setState(thisController.state);
          } else {
            thisController.state.noMatchingData = true;
            thisController.setState(thisController.state);
          }
        }
      },
      error: function (xhr) {

      },
    });

  };

  render() {
    const { loadedData } = this.state;
    const contactUs_column = [
      {
        name: <b style={{ fontSize: "16px" }}>Type</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('availability'),
        // width:"180px",
        selector: (row) => (
          <div className="container-fluid" style={{ textAlign: "right", width: "176px" }}>
            <div className="container-fluid" style={{ textAlign: "right", width: "8.4vw", marginLeft: "-1.5vh" }}>
              <select
                className="input-group form-control select2 "
                onChange={(e) => this.availabilityHandleChange(row, e)}
                value={row.availability}
                id={"availability" + row.id}
                style={{
                  background: "white",
                  border: "none",
                  border:
                    row.id == undefined || row.id == this.state.editedId
                      ? "1px solid #D2D4DC"
                      : "none",
                  borderRadius: row.id == undefined ? "2px" : "none",
                }}
                disabled={row.id == "" ? false : row.id != this.state.editedId}
              >
                {this.loadedAvailability.map((availabilityInfo) => (
                  <option
                    key={availabilityInfo}
                    value={availabilityInfo["name"]}
                  >
                    {availabilityInfo["code"]}
                  </option>
                ))}
                <option hidden value="Select Availaility">
                  Select Availability
                </option>
              </select>
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Description</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('description'),
        selector: (row) => (
          <div name="description">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              id={"description" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.description}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>From Week Day</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('startWeekDay'),
        selector: (row) => (
          <div className="container-fluid" style={{ textAlign: "right", marginLeft: "-7px" }}>
            <select
              className="input-group form-control select2 "
              onChange={(e) => this.handleChangeStartWeekDay(row, e)}
              value={row.startWeekDay}
              id={"startWeekDay" + row.id}
              style={{
                background: "white",
                border: "none",
                border:
                  row.id == undefined || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == undefined ? "2px" : "none",
              }}
              disabled={row.id == "" ? false : row.id != this.state.editedId}
            >
              {this.loadedStartWeekDays.map((startDaysInfo) => (
                <option key={startDaysInfo} value={startDaysInfo}>
                  {startDaysInfo}
                </option>
              ))}
              <option hidden value="Select Days">
                Select Days
              </option>
            </select>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>To Week Day</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('endWeekDay'),
        selector: (row) => (
          <div className="container-fluid" style={{ textAlign: "right", marginLeft: "-7px" }}>
            <select
              className="input-group form-control select2 "
              onChange={(e) => this.handleChangeEndWeekDay(row, e)}
              value={row.endWeekDay}
              id={"endWeekDay" + row.id}
              style={{
                background: "white",
                border: "none",
                border:
                  row.id == undefined || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == undefined ? "2px" : "none",
              }}
              disabled={row.id == "" ? false : row.id != this.state.editedId}
            >
              {this.loadedEndWeekDays.map((endDaysInfo) => (
                <option key={endDaysInfo} value={endDaysInfo}>
                  {endDaysInfo}
                </option>
              ))}
              <option hidden value="Select Days">
                Select Days
              </option>
            </select>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Start Time</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('startTime'),
        selector: (row) => (
          <div name="startTime">
            <input
              disabled={row.id == "" ? false : row.id != this.state.editedId}
              type="time"
              className="form-control col-11"
              id={"startTime" + row.id}
              name="time"
              placeholder="Enter Time"
              value={row.startTime}
              style={{
                cursor: "pointer",
                border: "1px solid #D2D4DC",
                borderRadius: "4px",
              }}
              onChange={(e) => this.handleChangeStartTime(row, e)}
            />
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>End Time</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('endTime'),
        selector: (row) => (
          <div name="endTime">
            <input
              disabled={row.id == "" ? false : row.id != this.state.editedId}
              type="time"
              className="form-control col-11"
              id={"endTime" + row.id}
              name="time"
              placeholder="Enter Time"
              value={row.endTime}
              style={{
                cursor: "pointer",
                border: "1px solid #D2D4DC",
                borderRadius: "4px",
              }}
              onChange={(e) => this.handleChangeEndTime(row, e)}
            />
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Time Zone</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('timeZone'),
        selector: (row) => (
          <div className="container-fluid" style={{ textAlign: "right", marginLeft: "-7px" }}>
            <select
              className="input-group form-control select2 "
              id={"timeZone" + row.id}
              name="timeZone"
              style={{
                background: "white",
                border: "none",
                border:
                  row.id == undefined || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == undefined ? "2px" : "none",
              }}
              disabled={row.id == "" ? false : row.id != this.state.editedId}
              value={row.timeZone}
              onChange={(e) => this.timeZonehandleChange(row, e)}
            > {this.loadedTimeZone.map((timeZoneInfo) => (
              <option key={timeZoneInfo.timeZoneId} value={timeZoneInfo.timeZoneName}>
                {timeZoneInfo.timeZoneName + " " + timeZoneInfo.timeZoneId}
              </option>
            ))}
              <option hidden value="Select Time Zone">
                Select Time Zone
              </option></select>
          </div>
        ),
      },
     
      {
        name: <b style={{ fontSize: "16px" }}>Contact Number</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('contactNumber'),
        selector: (row) => (
          <div name="contactNumber">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              id={"contactNumber" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.contactNumber}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Address</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('address'),
        selector: (row) => (
          <div name="address">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              id={"address" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.address}
            </div>
          </div>
        ),
      },
      
      
      {
        name: <b style={{ fontSize: "16px" }}>Is Default</b>,
        width: "125px",
        selector: (row) => (
          <div name="isDefault">
            <label className="switch">
              <input
                type="checkbox"
                id={"isDefault" + row.id}
                defaultChecked={row.default}
                disabled={row.id == "" ? false : row.id != this.state.editedId}
                onChange={(e) => this.handleDefaultChange(row, e)}
              />
              <span className="slider round"></span>
            </label>
          </div>
        ),
      },
    
      {
        name: <b style={{ fontSize: "16px" }}>Action</b>,
        width: "130px",
        selector: (row) => (
          <div id="action">
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginLeft: "-6px",
              }}
            >
              <img
                className="img-responsive"
                // title={(row.id == "") ||
                //     (this.state.loadedData[row.id].id == this.state.editedId) ? 'Save' : 'Edit'}
                style={{
                  marginTop: "6px",
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                src={
                  row.id == ""
                    ? this.saveImageSrc
                    : row.id != this.state.editedId
                      ? this.editImageSrc
                      : this.saveImageSrc
                }
                onClick={(e) => {
                  row.id == ""
                    ? this.saveContactInfoDetails(row, e)
                    : row.id == this.state.editedId
                      ? this.updateContactInfoDetails(row, e)
                      : this.makeCelledit(row, e);
                }}
              />
            </button>

            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginLeft: "-6px",
              }}
              title="Delete"
            >
              <img
                className="img-responsive"
                src={"./assets/images/baseline_delete_white_24dp.png"}
                style={{
                  marginTop: "6px",
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                onClick={() =>
                  row.id === ""
                    ? this.fetchContactInfo()
                    : this.openDeletePopUp(row.id)
                }
              />
            </button>
          </div>
        ),
      },
    ];
    return (
      <div>
        {/* {this.state.showLoader && <div style={{display:"flex", alignItems:"center", justifyContent:"center", height:"80vh", paddingLeft: "10vw"}} ><div className='loader'></div></div>} */}

        <div style={{ marginRight: "1%" }} id="contactUsTab">
          {/* <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!(this.state.showLoader)}
                    height={400}
                    width={50}
                    style={{ textAlign: 'center' }} /> */}
          <div
            style={{
              background: "#F9F9FB",
              display: this.state.showLoader ? "block" : "none",
            }}
          >
            <link rel="stylesheet" href="assets/css/toggleButton.css" />

            <link rel="stylesheet" href="assets/css/ReactToastify.css" />
            <link
              rel="stylesheet"
              href="assets/css/React_Table_CSS/react-table.css"
            />
            <link href="assets/css/ej2-base.css" rel="stylesheet" />
            <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
            <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
            <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
            <link href="assets/css/screenResolution.css" rel="stylesheet" />
            <link
              rel="shortcut icon"
              type="image/png"
              href="assets/images/bot.ico"
            />
            <link
              rel="stylesheet"
              href="plugins/font-awesome/css/font-awesome.min.css"
            />
            <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
            <link rel="stylesheet" href="assets/css/adminlte.css" />
            <link rel="stylesheet" href="assets/css/custom-style.css" />
            <link rel="stylesheet" href="assets/css/styles.css" />
            <link rel="stylesheet" href="assets/css/toggleButton.css" />

            <div className="row">
              <div className="col-sm-3">
                <h6
                  className="nav-item"
                  style={{ color: "#282a65", marginTop: "1.5vh" }}
                >
                  Contact Information
                </h6>
              </div>
              <div className="col-sm-5" Align="right" style={{ marginLeft: "15vw" }}>
                <input
                  type="text"
                  style={{
                    width: "12vw",
                    border: "2px solid #777676",
                    borderRadius: "10px",
                    padding: "10px",
                    height: "0.7vw"
                  }}
                  value={this.state.searchTerm}
                  onChange={this.handleSearch}
                  placeholder="Search ..."
                />
              </div>
              <div className="col-sm-2" style={{ marginTop: '-18px', marginLeft: "-2vw" }}>
                <div className="d-flex flex-row-reverse pt-2" style={{ marginTop: '-1vh' }}>
                  <div className="p-2" style={{ marginBottom: "10px" }}>
                    <button
                      className="btn action-button"
                      id="addMsg"
                      title=" Add "
                      onClick={
                        this.state.disableAddButton
                          ? this.notifyMsgFieldEmpty
                          : this.addNewContactInfo
                      }
                    >
                      <img src="assets/images/add_white_24dp.png" />
                    </button>
                    <button
                      title="Refresh"
                      onClick={this.refreshData}
                      type="button"
                      className="btn action-button"
                    >
                      <img src="./assets/images/refresh_white_24dp.png"></img>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="row" style={{ textAlign: "left" }}>
              <div className="col-lg-12 ">
                {!this.state.noMatchingData &&
                  <div className="card">
                    {this.state.isLoading && (
                      <div style={{ padding: '20px', textAlign: 'center' }}>
                        <p>Loading ...</p>
                      </div>
                    )}
                    {!this.state.isLoading && this.state.loadedData.length === 0 && (
                      <div style={{ padding: '20px', textAlign: 'center' }}>
                        <p>There are no contact data present.</p>
                      </div>
                    )}
                    {(!this.state.isLoading && this.state.loadedData.length > 0) && (

                      <DataTable
                        columns={contactUs_column}
                        data={this.state.loadedData}
                        defaultPageSize={10}
                        defaultSortFieldName
                        fixedHeaderScrollHeight="400px"
                        pagination={this.state.paginationValue}
                        noDataComponent={<this.CustomNoDataComponent />}
                      />)}
                  </div>}
                <ToastContainer className="Toast-at-center" />
              </div>
            </div>
              <div className='card'>
                {this.state.noMatchingData &&
                  <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                    <p>No matching options found ...</p>
                  </div>
                }
              </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactUs;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ContactUs.js